import { extend } from 'sk-ui/lib/utils/util.js'
import { action } from 'sky-engine/api/index'

import ddFormForTemplate from './metaData/ddFormForTemplate'
import deliveryDeployProjectDetail from './metaData/deliveryDeployProjectDetail'

import { DELIVERY_PROJECT_MNG } from '@/api/apiModules'
import { updateFlowStatus, getDefaultProductVersion } from '@/api/deliveryProject'
import { getFeatureDetail } from '@/api/feature'
import { getIndustryList } from '@/api/setting'
import createTemplateDdProject from '@/components/CreateTemplateDdProject'
import feiShuDocumentDetail from '@/store/modules/common/metaData/feiShuDocumentDetail'
export default {
  ShowFeatureFeiShuDocument({ commit }, params) {
    getFeatureDetail({ id: params.id }).then(res => {
      const props = {
        params: {
          documentUrl: res.data.content.configStepLink
        }
      }
      this.dispatch('OpenFullDialog', {
        metaData: feiShuDocumentDetail,
        props,
        clone: true
      })
    })
    //
    // const props = {
    //   params: {
    //     documentUrl: 'https://ruijie.feishu.cn/docx/ZauOds7BCoTNYyx0cpPcFdCPnde?from=from_copylink'
    //   }
    // }
    // this.dispatch('OpenFullDialog', {
    //   metaData: feiShuDocumentDetail,
    //   props,
    //   clone: true
    // })
  },
  CreateDeliveryDetailProject({ commit }, params) {
    const props = {
      params: {
        projectId: null,
        flowStatus: 'MDR_DEPLOY_PROJECT_INIT'
      }
    }
    const deliveryDeployProjectDetailCopy = extend(true, {}, deliveryDeployProjectDetail)
    deliveryDeployProjectDetailCopy.breadcrumb = {
      title: null,
      action: '',
      class: ''
    }
    this.dispatch('OpenFullDialog', {
      metaData: deliveryDeployProjectDetailCopy,
      props,
      clone: true
    })
  },
  CreateDdProjectFromTem({ commit }, params) {
    getDefaultProductVersion({}).then(res => {
      const props = {
        params: {
          projectId: null,
          flowStatus: 'MDR_DEPLOY_PROJECT_INIT'
        },
        productName: res.data.content.productVersion
      }
      const ptFormCopy = extend(true, {}, ddFormForTemplate)
      ptFormCopy.breadcrumb = {
        title: null,
        action: '',
        class: ''
      }

      ptFormCopy.callBackAction = 'CreateDdProjectSuccessBack'
      ptFormCopy.view.content.unshift({
        $id: 'templateProjectIdLabel',
        $type: 'sky-relation-option',
        label: '项目模版',
        $el: { disabled: false, multiple: false },
        actions: {
          nativeOn: {
            click: 'UmRelationDdTemplateProject'
          },
          on: {
            updateValue: 'DdProjectTemplateFillBack'
          }
        },
        rules: [{ notEmpty: { message: '模版项目不能为空' } }]
      })

      ptFormCopy.view.content[2].$el = {}
      ptFormCopy.view.content[7].$el = {}

      getIndustryList({}).then(res => {
        var changeList = []
        for (const iterator of res.data.content.itemArr) {
          if (iterator.industryCode === 'QY') {
            changeList.push({
              id: iterator.id,
              value: iterator.id,
              label: iterator.industryName
            })
          }
        }
        ptFormCopy.view.content[1].$options = changeList

        this.dispatch('OpenFullDialog', {
          metaData: ptFormCopy,
          props
        })
      })
    })
  },
  CreateDdProjectSuccessBack({ commit }, params) {
    const props = {
      params: {
        projectId: params.response.data.content,
        flowStatus: 'MDR_DEPLOY_NETWORK_INFO',
        createBytmp: true,
        industryId: params.requestDatas.industryId
      }
    }
    updateFlowStatus({
      projectId: params.response.data.content,
      flowStatus: 'MDR_DEPLOY_NETWORK_INFO'
    }).then(res => {})
    const deliveryDeployProjectDetailCopy = extend(true, {}, deliveryDeployProjectDetail)
    deliveryDeployProjectDetailCopy.breadcrumb = {
      title: params.requestDatas.customer,
      action: '',
      class: ''
    }
    this.dispatch('OpenFullDialog', {
      metaData: deliveryDeployProjectDetailCopy,
      props
    })
  },
  UmRelationDdTemplateProject({ commit }, props) {
    import('./metaData/deliveryDeploy').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData.default)
      props.params = {
        isTemplate: true,
        flowStatus: 'MDR_DEPLOY_SOLUTION_BUILD'
      }
      metaDataCopy.listUrl = 'delivery/project/template/list'
      metaDataCopy.toolbar = {
        searchPlaceholder: 'pocMng.searchPlaceholder',
        searchFieldNameArr: ['customer', 'projectCode']
      }
      metaDataCopy.view.columns[0] = {
        props: {
          type: 'radio',
          width: 55
        }
      }
      metaDataCopy.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props, clone: false })
    })
  },
  DdProjectTemplateFillBack({ commit }, { rootView, value }) {
    action(DELIVERY_PROJECT_MNG, 'detail', {
      id: value.row.id
    }).then(result => {
      result.data.content.projectName = null
      result.data.content.customer = null
      result.data.content.salesIdLabel = null
      result.data.content.presalesIdLabel = null
      result.data.content.salesLeaderLabel = null
      result.data.content.contractNo = null
      result.data.content.salesLeaderLabelList = null
      result.data.content.postsalesIdLabelList = null
      result.data.content.extensionIdLabelList = null
      result.data.content.startTime = null
      result.data.content.projectCycle = null
      rootView.updateFormData(result.data.content)
    })
  },
  ShowdeliveryDeployProjectDetail({ commit }, params) {
    const props = {
      params: {
        projectId: params.row.id,
        customer: params.row.customer,
        projectCode: params.row.projectCode,
        flowStatus: params.row.flowStatus,
        industryId: params.row.industryId,
        createBytmp: false
      }
    }
    const deliveryDeployProjectDetailCopy = extend(true, {}, deliveryDeployProjectDetail)
    deliveryDeployProjectDetailCopy.breadcrumb = {
      title: params.row.name,
      action: '',
      class: ''
    }
    this.dispatch('OpenFullDialog', {
      metaData: deliveryDeployProjectDetailCopy,
      props
    })
  },
  SetDdProjectTemplate({ commit }, params) {
    var title = '设置交付部署项目【' + params.row.projectName + '】为模版项目'
    var dialog = params.viewController.$dialog({
      template: h => {
        const row = params.row
        return (
          <sky-create-template-dd-project
            row={row}
            onCb={function() {
              dialog.remove()
              params.viewController.fetch()
            }}
          />
        )
      },
      components: {
        createTemplateDdProject
      },
      props: {
        title: title,
        width: '45%',
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false
      }
    })
  }
}
